export default {
    route: {
        home: 'Home',
        monitor: 'monitor',
        application: 'application',
        business: 'business',
        device: 'device',
        exception: 'exception',
        account: 'account',
        log: 'log',
        sys: 'sys',
        instance: 'instance',
        map: 'map',
        grid: 'grid',
        scene: 'Organization Structure',
        organizationStructure: 'Organization Structure',
        history: 'history',
        monitorTask: 'monitor Task',
        proberange: 'proberange',
        collectRecord: 'collectRecord',
        contact: 'contact',
        alarmTrigger: 'alarmTrigger',
        incubator: 'incubator',
        fridge: 'fridge',
        car: 'car',
        refrigeratory: 'refrigeratory',
        sensor: 'sensor',
        gateway: 'gateway',
        display: 'display',
        relay: 'relay',
        ex: 'ex',
        exReason: 'exReason',
        user: 'user',
        role: 'role',
        noticelog: 'noticelog',
        sysLog: 'sysLog',
        param: 'param',
        forwarding: 'forwarding',
        resource: 'resource',
        probeunit: 'probeunit',
        customer: 'customer',
        // 前端添加
        personalinfo: 'Personalinfo',
        historyData: 'historyData',
        realtime: 'realtime',
        operateRecord: 'operate Record',
    }
}
